import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { ServiceSubscription } from '../../interfaces/service-subscription/service-subscription';
import { ServiceSubscriptionForCreation } from '../../interfaces/service-subscription/service-subscription-for-creation';
import { ServiceSubscriptionForUpdate } from '../../interfaces/service-subscription/service-subscription-for-update';
import { PaginatedRepository } from '../pagination/paginated.repository';
import { ToastrService } from 'ngx-toastr';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';

@Injectable({
  providedIn: 'root',
})
export class ServiceSubscriptionRepositoryServiceService extends PaginatedRepository<ServiceSubscription> {
  protected override _baseLink: string;

  constructor(
    http: HttpClient,
    messageService: ToastrService,
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
    super(
      http,
      messageService);

    this._currentParams = new HttpParams()
      .set('pageSize', 10);

    this._baseLinkTemplate = `${config.rootUrl}/Corporations/[0]/BillingDetails/[1]/ServiceSubscriptions`;
    this._baseLink = this._baseLinkTemplate
  }

  private generateHeaders = () => {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
  }

  public setAdminLink(corporationID: string) {
    this._baseLink = `${this.config.rootUrl}/Corporations/${corporationID}/ServiceSubscriptions`;
  }

  public getServiceSubscription = (corporationID: string, billingDetailsID: string, servicueSubscriptionID: string) => {
    this.populateBaseLink([corporationID, billingDetailsID]);

    return this.http.get<ServiceSubscription>(`${this._baseLink}/${servicueSubscriptionID}`, this.generateHeaders());
  }

  public createServiceSubscription = (corporationID: string, billingDetailsID: string, serviceSubscription: ServiceSubscriptionForCreation) => {
    this.populateBaseLink([corporationID, billingDetailsID]);

    return this.http.post<ServiceSubscription>(
      this._baseLink,
      serviceSubscription,
      this.generateHeaders());
  }

  public updateServiceSubscription = (corporationID: string, billingDetailsID: string, serviceSubscriptionID: string, serviceSubscription: ServiceSubscriptionForUpdate) => {
    this.populateBaseLink([corporationID, billingDetailsID]);

    return this.http.put(`${this._baseLink}/${serviceSubscriptionID}`, serviceSubscription, this.generateHeaders());
  }

  public deleteServiceSubscription = (corporationID: string, billingDetailsID: string, serviceSubscriptionID: string) => {
    this.populateBaseLink([corporationID, billingDetailsID]);

    return this.http.delete(`${this._baseLink}/${serviceSubscriptionID}`);
  };
}